export const CURRENT = 'current';
export const FUTURE = 'future';

export default { CURRENT, FUTURE };
